// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"_1g2wb","icon":"_2Hkdt","selectedText":"NxPFK","text":"_14YAu"};